export type Language = "en" | "th";

export const seoConfig = {
	siteName: {
		en: "ATF Altecflex",
		th: "เอทีเอฟ​ อัลเทกเฟล็กซ์​"
	} as Record<Language, string>,
	siteUrl: "https://www.altecflex.com",
	defaultImage: "/images/atf-og-image.jpg",
	company: {
		name: {
			en: "Altecflex Sdn Bhd",
			th: "บริษัท​ เอทีเอฟ​ อัลเทกเฟล็กซ์​ จำกัด"
		} as Record<Language, string>,
		legalName: "Altecflex Sdn Bhd",
		foundedYear: 2018,
		logo: "https://www.altecflex.com/logo.png",
		email: "admin@altecflex.com",
		location: "Puchong, Selangor, Malaysia"
	},
	social: {
		linkedin: "https://www.linkedin.com/company/altecflex",
	}
};

interface SEOContent {
	title: string;
	description: string;
	keywords: string;
}

export const pageSEO = {
	home: {
		en: {
			title: "ATF Altecflex - Digital Transformation & Technology Solutions",
			description: "Leading digital transformation service provider specializing in FinTech, banking, and insurance solutions. Expert in React development, full-stack solutions, and business transformation strategies across Malaysia and globally.",
			keywords: "digital transformation, fintech solutions, banking technology, insurance technology, React development, full-stack development, business transformation, IT consulting Malaysia, software development, digital innovation"
		},
		th: {
			title: "ATF Altecflex - บริการดิจิทัลทรานส์ฟอร์เมชันและโซลูชันเทคโนโลยี",
			description: "ผู้ให้บริการด้านดิจิทัลทรานส์ฟอร์เมชันชั้นนำ เชี่ยวชาญด้าน FinTech โซลูชันธนาคารและประกันภัย ผู้เชี่ยวชาญด้าน React พัฒนา full-stack และกลยุทธ์การเปลี่ยนแปลงธุรกิจในมาเลเซียและทั่วโลก",
			keywords: "ดิจิทัลทรานส์ฟอร์เมชัน, โซลูชั่นฟินเทค, เทคโนโลยีธนาคาร, เทคโนโลยีประกัน, พัฒนา React, พัฒนา full-stack, การเปลี่ยนแปลงธุรกิจ, IT consulting มาเลเซีย, พัฒนาซอฟต์แวร์, นวัตกรรมดิจิทัล"
		}
	} as Record<Language, SEOContent>,
	productListing: {
		en: {
			title: "Our Solutions - Digital Services & Products | ATF Altecflex",
			description: "Explore our comprehensive digital transformation solutions including core banking systems, digital banking, mobile applications, API integrations, and custom software development for insurance and financial services.",
			keywords: "digital banking solutions, core banking system, mobile app development, API integration, insurance technology, financial software, custom development, agile delivery, MVP development, digital products"
		},
		th: {
			title: "โซลูชันของเรา - บริการและผลิตภัณฑ์ดิจิทัล | ATF Altecflex",
			description: "สำรวจโซลูชันดิจิทัลทรานส์ฟอร์เมชันที่ครอบคลุม รวมถึงระบบธนาคารหลัก ดิจิทัลแบงก์กิ้ง แอปพลิเคชันมือถือ การรวมระบบ API และการพัฒนาซอฟต์แวร์สำหรับประกันภัยและบริการทางการเงิน",
			keywords: "โซลูชันดิจิทัลแบงก์กิ้ง, ระบบธนาคารหลัก, พัฒนาแอปมือถือ, API integration, เทคโนโลยีประกัน, ซอฟต์แวร์การเงิน, custom development, agile delivery, พัฒนา MVP, ผลิตภัณฑ์ดิจิทัล"
		}
	} as Record<Language, SEOContent>
};